import cc from "classcat";

const Image = ({
  src,
  alt = "",
  responsive = true,
  className = "",
  ...props
}) => (
  <img
    src={src}
    alt={alt}
    className={cc([{ "img-responsive": responsive }, className])}
    {...props}
  />
);

export default Image;
